export type DiscussionSort =
  | 'latest'
  | 'newest'
  | 'oldest'
  | 'helpful'
  | 'rating:asc'
  | 'rating:desc';

export type DiscussionFilter = 'all' | 'unresolved' | 'unapproved';

export type CommentUser = {
  id: number;
  avatar: string;
  username: string;
  date_joined: string;
  deals_purchased: number;
  comment_whitelist: boolean;
  comment_blacklist: boolean;
  has_briefcase?: boolean;
  has_plus?: boolean;
};

export type Question = {
  id: number;
  level: number;
  user: CommentUser;
  submit_date: string;
  purchased: boolean;
  rating: never;
  title?: string | null;
  comment: string;
  display_path: string;
  children?: Comment[];
  approved?: boolean;
  resolved: boolean;
  num_likes: number;
};

export type Review = {
  id: number;
  level: number;
  user: CommentUser;
  submit_date: string;
  purchased: boolean;
  rating?: number | null;
  title?: string | null;
  comment: string;
  display_path: string;
  children?: Comment[];
  approved?: boolean;
  resolved: never;
  num_likes: number;
};

export type Comment = Question | Review;

export interface DiscussionStatusTag {
  text: string;
  bgColor: string;
}

export const DISCUSSION_QUESTIONS = 'questions';
export const DISCUSSION_REVIEWS = 'reviews';

export type DiscussionType =
  | typeof DISCUSSION_QUESTIONS
  | typeof DISCUSSION_REVIEWS;
